if (!customElements.get('carousel-tabs')) {
  customElements.define(
    'carousel-tabs',
    class CarouselTabs extends HTMLElement {
      constructor() {
        super();
      }

      connectedCallback() {
        this.slider = this.querySelector('[data-flickity-config]');
        this.flickity = new Flickity(
          this.slider,
          JSON.parse(this.slider.getAttribute('data-flickity-config'))
        );

        this.cells = this.querySelectorAll('.carousel-tabs__cell');
        this.pills = this.querySelectorAll('.carousel-tabs__pill');

        this.pills.forEach((pill) => {
          pill.addEventListener('click', this.bindPillClick.bind(this));
        });
      }

      bindPillClick(event) {
        const pill = event.target;
        const activeCategory = pill.dataset.cat;

        this.updateActivePill(pill);
        this.updateActiveCategory(activeCategory);
      }

      updateActivePill(pill) {
        this.pills.forEach((p) => {
          p.classList.remove('bg-black', 'text-white', 'active');
        });
        pill.classList.add('bg-black', 'text-white', 'active');
      }

      updateActiveCategory(activeCategory) {
        let firstVisibleIndex = null;

        this.cells.forEach((cell, index) => {
          if (activeCategory === 'all' || cell.dataset.cat === activeCategory) {
            cell.style.display = '';
            if (firstVisibleIndex === null) firstVisibleIndex = index;
          } else {
            cell.style.display = 'none';
          }
        });

        this.flickity.reloadCells();
        this.flickity.resize();

          if (activeCategory === 'all' && firstVisibleIndex !== null) {
          this.flickity.select(firstVisibleIndex);
        }
      }
    }
  );
}
